.container {
  padding: var(--space-l) var(--space-m) var(--space-s);
  background: var(--color-body);
  border-radius: var(--border-radius-xs);
  margin-bottom: var(--space-m);
}
